import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { combineReducers, configureStore, createSlice, createStore, nanoid, PayloadAction } from '@reduxjs/toolkit';
import { Vector } from './Utils/Vector';

export type Point = [number, number]

export type Port = {
  position: Point,
  direction: Vector,
}
export type Connection = {
  id: string
  ports: [Port, Port]
  width: number
  spacing: number
  minBendRadius: number
  modifyLength: boolean
  length: number | undefined
  color?: string
}

export type Obstacle = {
  id: string
  points: Point[]
  color?: string
}

export type RoutingResult = {
  connection: string
  channel: Channel | undefined
  routingFound: boolean
  routingWithLengthFound: boolean
}

export type Channel = {
  path: ChannelPath
  width: number
  length: number
}

export type ChannelPath = {
  startPoint: Point
  arcs: ChannelPathArc[]
  endPoint: Point
  pathString: string
  length: number
}

export type ChannelPathArc = {
  startPoint: Point
  startDirection: Vector
  endPoint: Point
  endDirection: Vector
  center: Point
  radius: number
  rotation: number
  length: number
}

export type InputConfiguration = {
  obstacles: Obstacle[]
  connections: Connection[]
}

export type OutputConfiguration = {
  channels: Record<string, RoutingResult>
}

export type Settings = {
  obstacleDefaultColor: string
  connectionDefaultColor: string
  interactionPointRadius: number
  positionInteractionPointRadius: number
  firstInteractionPointRadius: number
  portsSnapToObstacles: boolean
  positionsSnapToGrid: boolean
  gridSize: number
}

const settingsInitialState: Settings = {
  obstacleDefaultColor: '#888',
  connectionDefaultColor: '#111',
  interactionPointRadius: 8,
  positionInteractionPointRadius: 10,
  firstInteractionPointRadius: 12,
  portsSnapToObstacles: true,
  positionsSnapToGrid: false,
  gridSize: 5
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState: settingsInitialState,
  reducers: {
    updateObstacleDefaultColor: (state, action: PayloadAction<string>) => {
      state.obstacleDefaultColor = action.payload
    },

    updateConnectionDefaultColor: (state, action: PayloadAction<string>) => {
      state.connectionDefaultColor = action.payload
    },
  }
})

/*
const inputConfigurationInitialState: InputConfiguration = {
  obstacles: [{
    id: nanoid(),
    points: [[0, 4000], [300, 4000], [300, 0], [0, 0]]
  }, {
    id: nanoid(),
    points: [[10000, 4000], [10300, 4000], [10300, 0], [10000, 0]]
  }],
  connections: [{
    id: nanoid(),
    ports:[{
      position: [300, 500],
      direction: [1, 0]
    }, {
      position: [10000, 1000],
      direction: [-1, 0]
    }],
    width: 100,
    spacing: 50,
    minBendRadius: 150,
    modifyLength: true,
    length: 15000
  }, {
    id: nanoid(),
    ports:[{
      position: [300, 1400],
      direction: [1, 0]
    }, {
      position: [10000, 2000],
      direction: [-1, 0]
    }],
    width: 100,
    spacing: 50,
    minBendRadius: 150,
    modifyLength: true,
    length: 20000
  }, {
    id: nanoid(),
    ports:[{
      position: [300, 3500],
      direction: [1, 0]
    }, {
      position: [10000, 3400],
      direction: [-1, 0]
    }],
    width: 100,
    spacing: 50,
    minBendRadius: 150,
    modifyLength: true,
    length: 25000
  }]
}*/

/*const inputConfigurationInitialState: InputConfiguration = {
  obstacles: [{
    id: nanoid(),
    points: [[0, 300], [300, 300], [300, 0], [0, 0]]
  }, {
    id: nanoid(),
    points: [[1000, 300], [1300, 300], [1300, -200], [1000, -200]]
  }, {
    id: nanoid(),
    points: [[500, 800], [500, 1100], [1300, 1100], [1300, 800]]
  }, {
    id: nanoid(),
    points: [[0, 2500], [0, 3000], [500, 3000]]
  }],
  connections: [{
    id: nanoid(),
    ports:[{
      position: [300, 100],
      direction: [1, 0]
    }, {
      position: [1000, 100],
      direction: [-1, 0]
    }],
    width: 100,
    spacing: 50,
    minBendRadius: 150,
    modifyLength: false,
    length: undefined
  }, {
    id: nanoid(),
    ports:[{
      position: [0, 2700],
      direction: [-1, 0]
    }, {
      position: [100, 300],
      direction: [0, 1]
    }],
    width: 100,
    spacing: 50,
    minBendRadius: 150,
    modifyLength: true,
    length: 4700
  }, {
    id: nanoid(),
    ports:[{
      position: [300, 3000],
      direction: [0, 1]
    }, {
      position: [1050, 300],
      direction: [0, 1]
    }],
    width: 100,
    spacing: 50,
    minBendRadius: 150,
    modifyLength: true,
    length: 3945
  }]
}*/

const inputConfigurationInitialState: InputConfiguration = {
  "obstacles": [{
    "id": "hX_VDbtNaNqi25pLppnxd",
    "points": [
      [-0.142096042633057, -52.5194091796875],
      [446.3394470214844, -52.47441864013672],
      [446.81695556640625, 469.636962890625],
      [-5.187085151672363, 469.93450927734375]
    ]
  }, {
    "id": "iVE8vyHHokuGBFyz5siwH",
    "points": [
      [1662.5107421875, 9.762704849243164],
      [1642.285400390625, 542.3637084960938],
      [2316.4638671875, 555.8472290039062],
      [2316.4638671875, 29.98805809020996]
    ]
  }, {
    "id": "XgzimrEBQ9At7oIweOf70",
    "points": [
      [-22.935388565063477, 1789.5938720703125],
      [698.435546875, 1789.5938720703125],
      [1055.7501220703125, 2221.068115234375],
      [1062.491943359375, 3090.75830078125],
      [-43.160743713378906, 3077.274658203125]
    ]
  }, {
    "id": "bGQTlxpGzVNGn4qRkrQGu",
    "points": [
      [2619.84423828125, 2234.551513671875],
      [2984.1849143233667, 1789.3805403316944],
      [3401.89111328125, 1796.335693359375],
      [3388.40771484375, 3137.95068359375],
      [2599.618896484375, 3131.208984375]
    ]
  }, {
    "id": "yJ8gDD5eYu1hxgb1CvEyY",
    "points": [
      [1575.776838737709, 1848.3707340733527],
      [1575.776838737709, 1413.8164127842902],
      [2182.131575065834, 1413.8164127842902],
      [2182.919905143959, 1848.5825260655402]
    ]
  }],
  "connections": [{
    "id": "sl1vnaeNTOdOT__kM5bUS",
    "ports": [{
      "position": [1655.8444699180989, 185.30798546421929],
      "direction": [-532.6010036468506, -20.225341796875]
    }, {
      "position": [-2.557458918769379, 197.61310287510403],
      "direction": [-522.4539184570312, -5.044989109039307]
    }],
    "width": 100,
    "spacing": 50,
    "minBendRadius": 100,
    "modifyLength": false,
    length: undefined
  }, {
    "id": "FK6zJjRkIFBE_3h3P0UeN",
    "ports": [{
      "position": [866.3552823632227, 1992.364891815272],
      "direction": [431.4742431640625, -357.3145751953125]
    }, {
      "position": [1983.1562403098374, 549.1811006065284],
      "direction": [-13.4835205078125, 674.178466796875]
    }],
    "width": 100,
    "spacing": 50,
    "minBendRadius": 100,
    "modifyLength": true,
    "length": 5000
  }, {
    "id": "XdxKpzaH_GOmAS8GRvXvQ",
    "ports": [{
      "position": [199.54350280761724, 1789.5938720703125],
      "direction": [0, -721.3709354400635]
    }, {
      "position": [164.35184999552405, 469.8229047494704],
      "direction": [0.29754638671875, 452.0040407180786]
    }],
    "width": 150,
    "spacing": 50,
    "minBendRadius": 150,
    "modifyLength": false,
    length: undefined
  }, {
    "id": "hEXI173KRZ3dYfH14PFW1",
    "ports": [{
      "position": [1059.194527796043, 2665.3940215839184],
      "direction": [869.690185546875, -6.7418212890625]
    }, {
      "position": [2610.9309294774275, 2629.7084908887628],
      "direction": [-896.657470703125, -20.225341796875]
    }],
    "width": 150,
    "spacing": 50,
    "minBendRadius": 150,
    "modifyLength": true,
    "length": 3089.4409320717646
  }, {
    "id": "lfMLjdDRRXWMiEbV2xC9z",
    "ports": [{
      "position": [3395.112658698391, 2470.800393126311],
      "direction": [1341.614990234375, 13.4833984375]
    }, {
      "position": [2316.4638671875, 281.9540100097656],
      "direction": [525.8591709136963, 0]
    }],
    "width": 100,
    "spacing": 50,
    "minBendRadius": 100,
    "modifyLength": false,
    length: undefined
  }]
}

const inputConfigurationSlice = createSlice({
  name: 'inputConfiguration',
  initialState: inputConfigurationInitialState,
  reducers: {
    setInputConfiguration: (state, action: PayloadAction<InputConfiguration>) => {
      state.connections = action.payload.connections
      state.obstacles = action.payload.obstacles
    },

    addObstacle: {
      reducer(state, action: PayloadAction<Obstacle>) {
        state.obstacles.push(action.payload)
      },
      prepare(points: Point[]) {
        return {
          payload: {
            id: nanoid(),
            points: points
          }
        }
      }
    },

    deleteObstacle: (state, action: PayloadAction<string>) => {
      const i = state.obstacles.findIndex(obstacle => obstacle.id === action.payload)
      state.obstacles.splice(i, 1)
    },

    addConnection: {
      reducer(state, action: PayloadAction<Connection>) {
        state.connections.push(action.payload)
      },
      prepare({ ports, width, spacing, minBendRadius, modifyLength, length }: {
        ports: [Port, Port],
        width: number,
        spacing: number,
        minBendRadius: number
        modifyLength: boolean
        length: number | undefined
      }) {
        return {
          payload: {
            id: nanoid(),
            ports,
            width,
            spacing,
            minBendRadius,
            modifyLength,
            length
          }
        }
      }
    },

    deleteConnection: (state, action: PayloadAction<string>) => {
      const i = state.connections.findIndex(connection => connection.id === action.payload)
      state.connections.splice(i, 1)
    },

    updateConnection: (state, action: PayloadAction<Connection>) => {
      const i = state.connections.findIndex(connection => connection.id === action.payload.id)
      state.connections[i] = action.payload
    },

    updateObstacle: (state, action: PayloadAction<Obstacle>) => {
      const i = state.obstacles.findIndex(obstacle => obstacle.id === action.payload.id)
      state.obstacles[i] = action.payload
    }
  }
})

const outputInitialState: OutputConfiguration = {
  channels: {}
}

const outputSlice = createSlice({
  name: 'output',
  initialState: outputInitialState,
  reducers: {
    updateChannels: (state, action: PayloadAction<Record<string, RoutingResult>>) => {
      state.channels = action.payload
    },
  }
})

const store = configureStore({
  reducer: {
    inputConfiguration: inputConfigurationSlice.reducer,
    settings: settingsSlice.reducer,
    output: outputSlice.reducer
  },
})

export const { updateConnection, updateObstacle, addObstacle, deleteObstacle, addConnection, deleteConnection, setInputConfiguration } = inputConfigurationSlice.actions
export const { updateChannels } = outputSlice.actions


export type RootState = ReturnType<typeof store.getState>

ReactDOM.render(
  <React.StrictMode>
  <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
